import useJwt from '@/auth/jwt/useJwt'

// initial state
const state = () => ({})

// getters
const getters = {}

// actions
const actions = {
  exchangeCodeForToken({ commit }, params) {
    return new Promise((resolve, reject) => {
      const param = { url: '/internal/oauth/code-exchange', rawData: params, id: null }
      useJwt.postput(param)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            useJwt.setToken(response.data.data.token)
            useJwt.setRefreshToken(response.data.data.refresh_token)
            resolve(response)
          }
        },
        error => {
          reject(error.response)
        })
    })
  },
}

// mutations
const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
